import { IDeleteProjetoRevisaoResumoUseCase } from "../../../presentation/useCases/delete/delete_projeto_revisao_resumo_use_case";
import { IProjetosRepository } from "../../repositories/projetos_repository";


export class DeleteProjetoRevisaoResumoUseCase implements IDeleteProjetoRevisaoResumoUseCase {
  constructor(private readonly repository: IProjetosRepository) {}

  async deleteProjetoRevisaoResumo(IdProjetoRevisaoResumo: number): Promise<void> {
    await this.repository.deleteProjetoRevisaoResumo( IdProjetoRevisaoResumo);
  }
}
